var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 13,
    viewBox: "0 0 4 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666992 6.00302C0.666992 5.26664 1.26395 4.66969 2.00033 4.66969C2.73671 4.66969 3.33366 5.26664 3.33366 6.00302C3.33366 6.7394 2.73671 7.33635 2.00033 7.33635C1.26395 7.33635 0.666992 6.7394 0.666992 6.00302Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666992 10.6697C0.666992 9.93331 1.26395 9.33636 2.00033 9.33636C2.73671 9.33636 3.33366 9.93331 3.33366 10.6697C3.33366 11.4061 2.73671 12.003 2.00033 12.003C1.26395 12.003 0.666992 11.4061 0.666992 10.6697Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666992 1.33635C0.666992 0.599975 1.26395 0.00302124 2.00033 0.00302124C2.73671 0.00302124 3.33366 0.599975 3.33366 1.33635C3.33366 2.07273 2.73671 2.66969 2.00033 2.66969C1.26395 2.66969 0.666992 2.07273 0.666992 1.33635Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots_vertical.1952a451673cff1750d1940a2132392f.svg";
export { ForwardRef as ReactComponent };